import styled, { css } from 'styled-components';
import { MediaQuery } from '../../../theme/style-helpers';
import { CellValue, Table, TableCell } from '../css';

export const ServiceAndPricingTable = styled(Table)`
    row-gap: 28px;

    ${MediaQuery.medium(css`
        grid-template-columns: 1fr 1fr;
        column-gap: 64px;
    `)};
`;

export const ServiceDetailsContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 12px;
`;

export const ServiceDetailsTableCell = styled(TableCell)`
    flex-direction: row;
    justify-content: space-between;

    ${MediaQuery.medium(css`
        justify-content: unset;
    `)};
`;

export const InvoiceTable = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 8px;
    padding: 0 4px;

    ${MediaQuery.medium(css`
        row-gap: 4px;
    `)};
`;

export const InvoiceTableCell = styled(TableCell)`
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
`;

export const InvoiceCellText = styled(CellValue)`
    font-size: 14px;

    ${MediaQuery.medium(css`
        font-size: 16px;
    `)};
`;
